import CountUp from 'react-countup';
import { useInView } from "react-intersection-observer";

export default function StatsSection() {
  const { ref, inView } = useInView({ triggerOnce: true });

  const stats = [
    { value: 2014, suffix: "", label: "Product launched" },
    { value: 2500, suffix: "+", label: "employees" },
    { value: 200, suffix: "+", label: "countries use monday.com" },
    { value: 2, suffix: "m", label: "board actions are made every day" },
    { value: 245, suffix: "K", label: "customers use monday.com to manage their work" },
  ];

  return (
    <section className="bg-[#0AC0AB] py-16 text-white">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-4xl sm:text-5xl font-extrabold mb-12">
          monday.com by the numbers
        </h2>
        <div
          ref={ref}
          className="grid grid-cols-1 md:grid-cols-5 gap-6 md:gap-0 bg-[#0AC0AB] rounded-2xl overflow-hidden"
        >
          {stats.map((item, index) => (
            <div
              key={index}
              className={`flex flex-col items-center justify-center px-4 py-6 ${
                index !== stats.length - 1 ? "border-r border-white/40" : ""
              }`}
            >
              <div className="text-3xl sm:text-4xl font-extrabold">
                {inView ? (
                  <CountUp end={item.value} duration={2} suffix={item.suffix} />
                ) : (
                  "0"
                )}
              </div>
              <p className="mt-2 text-sm sm:text-base">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}